var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-table",
    _vm._g(
      _vm._b(
        {
          ref: "WeforsysTable",
          staticClass: "Weforsys-common-table",
          attrs: {
            data: _vm.data,
            height: _vm.height,
            "element-loading-text": _vm.$t("common.loadingText"),
            border: _vm.border,
          },
        },
        "el-table",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _vm.hasC
        ? _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              type: "selection",
              width: "50",
              align: "center",
            },
          })
        : _vm._e(),
      _vm.hasNO
        ? _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              type: "index",
              width: "50",
              label: "序号",
              align: "center",
              index: _vm.indexMethod,
            },
          })
        : _vm._e(),
      _vm._t("default"),
      _c(
        "template",
        { slot: "empty" },
        [
          _c("el-empty", {
            attrs: { description: "暂无数据", "image-size": 120 },
          }),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }